import React, { useState } from 'react'

// icons
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

export default function FAQs() {
    // states
    const [accActiveList, setAccActiveList] = useState([])

    // head click
    const handleHeadClick = (ev, id) => {
        ev.preventDefault()

        if (id) {
            const isIdExist = accActiveList.find(item => item === id)

            if (isIdExist) { // if id exists in the filter then remove it
                const updatedList = accActiveList.filter(item => item !== id)

                setAccActiveList(updatedList) // setting filter ids
            } else { // if id does not exists then add it
                setAccActiveList([...accActiveList, id])  // setting filter ids
            }
        }
    }
    return (
        <div className="accordian-view">
            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId1") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId1")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">What forms of payment do you accept?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId1") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId1") ? (
                        <div className="acc-content">
                            <p className="item mb-0">We accept the following major credit cards: Visa, MasterCard and American Express.</p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId2") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId2")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">When will my credit card be charged?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId2") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId2") ? (
                        <div className="acc-content">
                            <p className="item mb-0">Credit cards will be processed 1-2 business days prior to shipping. You will only be charged on the merchandise that is available to ship.</p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId3") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId3")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">Do you ship to PO Boxes?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId3") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId3") ? (
                        <div className="acc-content">
                            <p className="item mb-0">Unfortunately, due to the size of our items, we cannot ship to PO boxes.</p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId4") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId4")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">I have a damaged item, what should I do?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId4") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId4") ? (
                        <div className="acc-content">
                            <p className="item mb-0">
                                Please contact customer service at <a href="mailto:support@ruhlisticdecor.com">support@ruhlisticdecor.com</a>  and we will be happy to assist you with your request.
                            </p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId5") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId5")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">I am not happy with my purchase and would like to setup a return. What should I do?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId5") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId5") ? (
                        <div className="acc-content">
                            <p className="item mb-0">
                                Please contact customer service at <a href="mailto:support@ruhlisticdecor.com">support@ruhlisticdecor.com</a>  and we will be happy to assist you with your request.
                            </p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId6") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId6")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">What if my item is backordered? </span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId6") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId6") ? (
                        <div className="acc-content">
                            <p className="item mb-3">
                                Ruhlistic Dècor strives to have every product in stock and available to ship. If an item is not available for immediate shipment, it will be backordered and will ship automatically once it comes back to stock. If you would like to cancel a backorder, please email us at support@ruhlisticdecor.com, and we will be happy to assist you with your request.
                            </p>
                            <p className="item mb-3">
                                **please note that you will not be charged for backordered items until they ship.
                            </p>
                            <p className="item mb-0">
                                **If your backorder is under $50 or older than 6 months, we reserve the right to cancel.
                            </p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId7") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId7")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">How are your products measured?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId7") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId7") ? (
                        <div className="acc-content">
                            <p className="item mb-0">
                                Measurements listed are Length x Width x Height
                            </p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId8") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId8")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">Where does your product come from?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId8") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId8") ? (
                        <div className="acc-content">
                            <p className="item mb-0">
                                We source product from 15 countries around the world, partnering with artisans and companies that stand behind design and support unique offerings that we can pass along to our customers.
                            </p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId9") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId9")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">Where does your product come from?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId9") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId9") ? (
                        <div className="acc-content">
                            <p className="item mb-0">
                                Most of our products are made by hand using traditional techniques and materials, which results in one-of-a-kind pieces! As a result, variation in coloring, shapes, and size are to be expected.
                            </p>
                        </div>
                    ) : null
                }
            </div>

            {/* acc item */}
            <div className="accordian-item">
                {/* header */}
                <div
                    className={`acc-header ${accActiveList.find(item => item === "accId10") ? "active" : ""}`}
                    onClick={ev => handleHeadClick(ev, "accId10")}>
                    <p className="mb-0 d-flex align-items-center">
                        <span className="media-body">Are your products food safe?</span>
                        <span className="icon">
                            {
                                accActiveList.find(item => item === "accId10") ? (
                                    <AiOutlineMinus />
                                ) : (
                                    <AiOutlinePlus />
                                )
                            }
                        </span>
                    </p>
                </div>

                {
                    /* content */
                    accActiveList.find(item => item === "accId10") ? (
                        <div className="acc-content">
                            <p className="item mb-0">
                                Specific products are tested for food safety. They will be noted as so on the website. Ruhlistic Decor is committed to providing safe, high quality products for our customers. We conduct ongoing quality and safety testing for our products pursuant to all federal and state regulations.
                            </p>
                        </div>
                    ) : null
                }
            </div>



        </div>
    )
}
